import { Injectable } from '@angular/core';
import { Response } from "@angular/http";
import { Observer } from "rxjs/Observer";

import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { Observable } from "rxjs/Observable";
import "rxjs/Rx";
import { AuthHttp } from "angular2-jwt";
import { environment } from "../../../environments/environment";

@Injectable()
export class ProvinceResolver implements Resolve<Array<{ provinceId: number, provinceName: string, code: string }>> {
    constructor(private authHttp: AuthHttp) { }

    provinces: Array<{ provinceId: number, provinceName: string, code: string }> = null;

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Array<{ provinceId: number, provinceName: string, code: string }>> | Promise<Array<{ provinceId: number, provinceName: string, code: string }>> | Array<{ provinceId: number, provinceName: string, code: string }> {
        return Observable.create((observer: Observer<Array<{ provinceId: number, provinceName: string, code: string }>>) => {
            if (this.provinces != null) {
                observer.next(this.provinces);
                observer.complete();
            } else {
                const qs = environment.apiPath + '/api/lookups/getProvinces?languageId=1';

                this.authHttp.get(qs)
                    .map(
                    (response: Response) => {
                        return response.json();
                    }).subscribe(
                    (response: any) => {
                        this.provinces = response;
                        observer.next(response);
                        observer.complete();
                    },
                    (error: Error) => { });
            }
        });
    }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/services/lookups/province-resolver.service.ts